import React from "react";
import { Trans, useTranslation } from "react-i18next";

const Description = ({ isDataDriven }: { isDataDriven: boolean }) => {
    const { t } = useTranslation();

    return (
        <div className={"conditional_rebates_description"}>
            {isDataDriven ? (
                <Trans i18nKey={`ConditionalRebates.Description.dataDriven`} t={t} />
            ) : (
                <Trans i18nKey={`ConditionalRebates.Description.handRaisers`} t={t} />
            )}
        </div>
    );
};

export default Description;
